module.exports = __webpack_public_path__ + "media/blink3.916153ab.webm";